<template>
  <main class="main common_apply_list" role="main" v-if="isCompleted">
    <div class="main_con" id="main_con">
      <div class="sub_main">
        <div class="h_tab">
          <ul>
            <li>
              <button @click="goLink('Apply.Main')">인터넷</button>
            </li>
            <li class="on"><button>휴대폰</button></li>
          </ul>
        </div>
        <div class="n_suggest" id="con_info">
          <div class="regi_application">
            <div class="round_filter mt30">
              <ul>
                <li @click="selectSort">
                  <button>{{ isSortText }}</button>
                </li>
              </ul>
            </div>

            <ApplyList
              v-if="list.length > 0"
              :list="list"
              :isCustomer="isCustomer"
              :deal="deal"
              @enter-chat="enterChatRoom"
              @goReportStore="goReportStore"
              @apply-detail="goApplyDetail"
              @review-write="goToReviewWrite"
            />

            <div class="list_progress_none" v-else>
              <div v-if="deal == 'hanapay'">
                <p>
                  신청내역이 없습니다!<br />
                  하나페이 특가 상품을 둘러보세요!
                </p>
                <button class="hanapay_btn" @click="goMobileDeal()">
                  하나페이 특가 상품 보러가기 >
                </button>
              </div>
              <div v-else>
                <p>
                  신청내역이 없습니다!<br />
                  HOME 화면에서 나에게 맞는 상품을 찾아보세요!
                </p>
                <button class="home_btn" @click="goLink('Mobile.Main')">
                  HOME으로 가기
                </button>
              </div>
            </div>
          </div>
          <infinite-loading
            ref="infiniteLoading"
            :direction="direction"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <span slot="no-more"></span>
            <span slot="spinner"></span>
            <span slot="no-results"></span>
          </infinite-loading>
        </div>
      </div>
    </div>
    <SortModal :show="isSortOpen" @close="sortModalClose" ref="sortModal" />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import SortModal from '@/front/customer/views/internetApply/modal/SortModal';

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import ApplyList from '@common/components/mobile/ApplyList';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import InfiniteLoading from 'vue-infinite-loading';

import { sleep } from '@common/lib/common/utils';

export default {
  name: 'Mobile.ApplyList',
  components: {
    ApplyList,
    SortModal,
    InfiniteLoading,
  },
  data() {
    return {
      isTab_1: true,
      isTab_2: false,
      isCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      isSortOpen: false,
      isSortText: '최신 순',
      isSortRealText: '',
      isSearchSort: 'CREATED_AT_DESC', // CREATED_AT_ASC , CREATED_AT_DESC
      mobileApplyList: [],
      visitPage: 0,
      scrollLocation: 0,
      deal: '',
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async created() {
    localStorage.removeItem('redir');

    this.deal = this.$route.query.dl;

    // 특가 하나페이 일 경우에만 파라미터 달고 옴
    if (this.deal != 'hanapay') {
      this.deal = '';
    }

    this.$nextTick(() => {
      this.isCompleted = true;
    });
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  async mounted() {
    console.log('mounted = ' + new Date(new Date().getTime()));
    // 페이징 뒤로가기 설정 시작
    // this.list.length = 1;
    this.page = 1;
    if (this.visitPage > 0) {
      for (var i = 0; i < this.visitPage - 1; i++) {
        this.infiniteId += 1;
      }
    } else {
      this.infiniteId += 1; //리스트 가져오기.
    }

    // 페이징 뒤로가기 설정 끝
  },
  computed: {
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  methods: {
    ...mobileMapActions([mobileTypes.SELECT_MOBILE_APPLY_LIST]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.CREATE_CHATROOM,
    ]),
    async fetch(fromName) {
      console.log('fetch = ' + new Date(new Date().getTime()));
      const names = [
        'Mobile.ApplyDetail',
        'chat.room',
        'Report.Main',
        'Shops.Reviews',
        'Shops.WriteReview',
      ];
      if (names.indexOf(fromName) > -1) {
        const storage = JSON.parse(
          localStorage.getItem('mobile_apply_list_from_detail'),
        );
        if (storage) {
          this.visitPage = storage.page;
          this.scrollLocation = storage.scrollLocation;
          this.isSortText = storage.isSortText;
          this.isSearchSort = storage.isSearchSort;
          this.size = (storage.page - 1) * 10;
          this.isIng = storage.isIng;

          localStorage.removeItem('mobile_apply_list_from_detail');
        }
      }
    },
    saveScroll() {
      const target = document.querySelector('#con_info');
      let scrollLocation = target.scrollTop;
      console.log('scrollLocation');
      console.log(scrollLocation);
      const storage = {
        page: this.page,
        size: this.size,
        scrollLocation: scrollLocation,
        isSortText: this.isSortText,
        isSearchSort: this.isSearchSort,
        isIng: this.isIng,
      };

      localStorage.setItem(
        'mobile_apply_list_from_detail',
        JSON.stringify(storage),
      );
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#con_info');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';

        await this.getMobileApplyList();

        if (this.page == 1) {
          this.list = [];
        }
        if (this.mobileApplyList.length) {
          this.list.push(...this.mobileApplyList);

          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          // if (this.page == 1) {
          //   setTimeout(() => {
          //     this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
          //     //window.scrollTo(0, 0);
          //   }, 10);
          // } else {
          //   setTimeout(() => {
          //     if (this.visitPage >= this.page) {
          //       window.scrollTo(0, this.scrollLocation);
          //       this.page = this.visitPage;
          //     }
          //   }, 10);
          // }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    goApplyDetail(item) {
      // 뒤로가기 저장
      this.saveScroll();
      let title = '휴대폰 개통신청서';
      if (item.applyType == 'PROMISE') {
        title = '휴대폰 개통신청서(매장방문)';
      } else if (item.applyType == 'APPLY') {
        title = '휴대폰 개통신청서(비대면)';
      }

      this.$router.push({
        name: 'Mobile.ApplyDetail',
        params: {
          applyId: item.applyId,
          title: title,
        },
      });
    },
    async getMobileApplyList() {
      const params = {
        orderType: this.isSearchSort,
        page: this.page,
        size: this.size,
      };
      const mobileApplyList = await this[mobileTypes.SELECT_MOBILE_APPLY_LIST](
        params,
      );

      console.log('getMobileApplyList_params');
      console.log(params);

      this.mobileApplyList = mobileApplyList.content;
      console.log('this.mobileApplyList');
      console.log(this.mobileApplyList);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    selectSort() {
      this.isSortOpen = true;
    },
    async sortModalClose(checked) {
      if (checked) {
        this.isSortText = this.$refs.sortModal.selectSort;
        this.isSortRealText = this.$refs.sortModal.selectSortReal;
        this.isSearchSort = this.isSortRealText;

        this.scrollLocation = 0;
        this.getListPageOne();
      }

      this.isSortOpen = false;
    },
    goShopDetail(storeId) {
      // 뒤로가기 저장
      this.saveScroll();
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: storeId,
        },
      });
    },
    async enterChatRoom(storeId) {
      // 뒤로가기 저장
      this.saveScroll();
      this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      });

      let name = 'chat.room';
      const params = {};
      if (this.chatroom_with.count == 0) {
        // name = 'chat.room.create';
        // params.storeId = storeId;
        this[chatActions.CREATE_CHATROOM]({
          chatRoomType: 'OneOnOne',
          memberId: '',
          storeId: storeId,
          estimateId: undefined,
        }).then(() => {
          console.log('this.chatroom');
          console.log(this.chatroom);
          params.uuid = this.chatroom.uuid;

          this.$router.push({
            name,
            params,
          });
        });
      } else {
        params.uuid = this.chatroom_with.content[0].uuid;
        this.$router.push({
          name,
          params,
        });
      }
    },
    goToReview(item) {
      // 뒤로가기 저장
      this.saveScroll();
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: item.storeId },
        query: { type: 'mobile' },
      });
    },
    goToReviewWrite(item) {
      // 뒤로가기 저장
      this.saveScroll();
      this.$router.push({
        name: 'Shops.WriteReview',
        params: { id: item.storeId },
        query: { type: 'mobile' },
      });
    },
    goLink(link) {
      // 뒤로가기 저장
      this.saveScroll();
      this.$router.push({
        name: link,
      });
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '100x100', '18');

      return path;
    },
    goReportStore(item) {
      // 뒤로가기 저장
      this.saveScroll();
      this.$router.push({
        name: 'chat.report',
        query: {
          applyId: item.applyId,
          name: item.store.storeName,
        },
      });
    },
    goMobileDeal() {
      this.$router.push({
        name: 'Mobile.DealList',
        query: { dl: this.deal },
      });
    },
  },
};
</script>
